module.exports = __webpack_public_path__ + "img/vir.885ab554.png";